import { PayloadAction } from "@reduxjs/toolkit";
import { NavigationState } from "../../types";

import { ClientEventHistoryPathFilter } from "../../types";

export const addClientEventHistoryFilter = (
  state: NavigationState,
  { payload }: PayloadAction<ClientEventHistoryPathFilter>
) => {
  state.clientEventsPathFilters = [...state.clientEventsPathFilters, payload];
};
